export class EnvService {

  public baseUrl = '';
  public azuread_tenant = '';
  public webchat_feedbackFileURL = '';

  constructor() {
  }

}